/**
 * CollectionBadge — circular progress ring + "DRESSED have / total" counter.
 * Tracks how many equip slots are currently filled, so it fills as you dress the
 * character (a meaningful metric while the economy is free and everything is owned).
 */

import { Text, View } from 'react-native';
import Svg, { Circle, Text as SvgText } from 'react-native-svg';
import { darkTheme } from '../../../src/theme/themes';
import { collectionBadgeStyles as styles } from './CollectionBadge.styles';

interface CollectionBadgeProps {
  have: number;
  total: number;
}

const RING_SIZE = 36;
const STROKE = 3.5;

export function CollectionBadge({ have, total }: CollectionBadgeProps) {
  const pct = total > 0 ? Math.round((have / total) * 100) : 0;
  const radius = RING_SIZE / 2 - STROKE;
  const circumference = 2 * Math.PI * radius;
  const center = RING_SIZE / 2;
  const offset = circumference * (1 - pct / 100);

  return (
    <View style={styles.pill}>
      <Svg width={RING_SIZE} height={RING_SIZE} viewBox={`0 0 ${RING_SIZE} ${RING_SIZE}`}>
        <Circle cx={center} cy={center} r={radius} fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth={STROKE} />
        <Circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke={darkTheme.accent}
          strokeWidth={STROKE}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${center} ${center})`}
        />
        <SvgText x={center} y={center + 3.5} textAnchor="middle" fontSize={11} fontWeight="800" fill={darkTheme.white}>
          {pct}
        </SvgText>
      </Svg>
      <View>
        <Text style={styles.label}>DRESSED</Text>
        <Text style={styles.count}>
          {have}
          <Text style={styles.countTotal}> / {total}</Text>
        </Text>
      </View>
    </View>
  );
}
